import { inject, Injectable } from '@angular/core';
import { Objection } from '../models/objection.model';
import { DatabaseService, type QuerySignal } from './database.service';

/**
 * Read access to the org's objection list. Seeded in customer.sql; the admin
 * CRUD screen arrives in a later phase.
 */
@Injectable({
  providedIn: 'root',
})
export class ObjectionService {
  private db = inject(DatabaseService);

  /** Active, non-deleted objections in display order. */
  async getActive(): Promise<Objection[]> {
    await this.db.init();
    const rows = await this.db.exec(
      'SELECT * FROM objections WHERE is_active = 1 AND deleted_at IS NULL ORDER BY sort_order, label',
    );
    return rows as Objection[];
  }

  /** Every non-deleted objection, active or not — for rendering historical rows. */
  async getAll(): Promise<Objection[]> {
    await this.db.init();
    const rows = await this.db.exec(
      'SELECT * FROM objections WHERE deleted_at IS NULL ORDER BY sort_order, label',
    );
    return rows as Objection[];
  }

  createActiveQuery(): QuerySignal<Objection[]> {
    return this.db.createQuery('objections', () => this.getActive());
  }

  createQuery(): QuerySignal<Objection[]> {
    return this.db.createQuery('objections', () => this.getAll());
  }
}
